import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calculate" }
const _hoisted_2 = { class: "calculate-basic" }
const _hoisted_3 = { class: "row layout-responsive-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slider = _resolveComponent("slider")!
  const _component_info = _resolveComponent("info")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_slider, {
          id: "einnahmen",
          labelText: _ctx.textSliderEinnahmen,
          "slider-values": _ctx.sliderEinnahmen,
          "tooltip-text": _ctx.textToolTipEinnahmen,
          unit: "€",
          onValueChanged: _ctx.onEinnahmenChanged,
          short: true
        }, null, 8, ["labelText", "slider-values", "tooltip-text", "onValueChanged"]),
        (_ctx.sliderEinnahmen.value > 0)
          ? (_openBlock(), _createBlock(_component_slider, {
              key: 0,
              id: "ausgaben",
              labelText: _ctx.textSliderAusgaben,
              "slider-values": _ctx.sliderAusgaben,
              "tooltip-text": _ctx.textToolTipAusgaben,
              unit: "€",
              onValueChanged: _ctx.onAusgabenChanged,
              short: true
            }, null, 8, ["labelText", "slider-values", "tooltip-text", "onValueChanged"]))
          : _createCommentVNode("", true),
        _createVNode(_component_info, {
          id: "hinweis-rate",
          text: _ctx.hinweisRate,
          show: _ctx.hinweisRate != ''
        }, null, 8, ["text", "show"])
      ]),
      _createVNode(_component_slider, {
        id: "eigenkapital",
        labelText: _ctx.textSliderEigenkapital,
        "slider-values": _ctx.sliderEigenkapital,
        "slider-to-input-conversion": 1000,
        "tooltip-text": _ctx.textToolTipEigenkapital,
        unit: ".000 €",
        onValueChanged: _ctx.onEigenkapitalChanged,
        onValueOutOfRange: _ctx.onEigenkapitalOutOfRange,
        "hinweis-type": "info"
      }, null, 8, ["labelText", "slider-values", "tooltip-text", "onValueChanged", "onValueOutOfRange"]),
      _createVNode(_component_slider, {
        id: "kaufpreis",
        labelText: _ctx.textSliderKaufpreis,
        "slider-values": _ctx.sliderPreis,
        "slider-to-input-conversion": 1000,
        "tooltip-text": _ctx.textToolTipKaufpreis,
        unit: ".000 €",
        onValueChanged: _ctx.onKaufpreisChanged
      }, null, 8, ["labelText", "slider-values", "tooltip-text", "onValueChanged"])
    ])
  ]))
}